<template>
  <component
    :is="tag"
    :class="[
      $style.button,
      $kindStyle[kindClass],
      $sizeStyle[sizeClass],
      { [$style.fit]: fit },
      { [$style.unread]: existsUnread },
    ]"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </component>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'AtomButton',
  props: {
    tag: {
      type: String,
      default: 'button',
    },
    fit: {
      type: Boolean,
      default: false,
    },
    existsUnread: {
      type: Boolean,
      default: false,
    },
    kindClass: {
      type: String,
      required: true,
    },
    sizeClass: {
      type: String,
      required: true,
    },
  },
});
</script>

<style lang="scss" module>
.button {
  display: block;
  position: relative;
  box-sizing: border-box;
  text-decoration: none;
  text-shadow: none;
  text-align: center;
  font-weight: bold;
  cursor: pointer;
  max-width: 100%;
  width: auto;
  transition: 0.1s;

  &.fit {
    width: 100%;
  }

  &.unread::after {
    content: '';
    width: 14px;
    height: 14px;
    background: $COLOR_ATTENTION;
    border-radius: $BORDER_RADIUS_CIRCLE;
    box-shadow: $SHADOW_ATTENTION;
    position: absolute;
    top: -7px;
    right: 0;
  }

  &:disabled {
    opacity: 0.4;
  }
}
</style>

<!-- styles by props -->
<style lang="scss" module="$kindStyle">
@use '@/components/atoms/AtomButtonKindStyle.scss' as *;
@include kindStyle();
</style>

<style lang="scss" module="$sizeStyle">
.small {
  height: 30px;
  line-height: 28px;
  font-size: 12px;
  border-radius: 15px;
  padding: 0 20px;
}

.large {
  height: 40px;
  line-height: 38px;
  font-size: 14px;
  border-radius: 20px;
  padding: 0 30px;
}
</style>
